import React from 'react'

export const Responsive = props => {
  return <h2>Responsive</h2>
}
